// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1veCC","image":"Header_image__2uIiL","name":"Header_name__2tbES","info":"Header_info__1SxlQ","infoRow":"Header_infoRow__3fgnF"};